import axios from "axios";

const api = axios.create({
  baseURL: "https://sj.nwayami.com/api/",
});

// Interceptor de REQUISIÇÃO
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Garante que URLs terminem com / para evitar erro 403 no Django
    if (config.url && !config.url.endsWith('/') && !config.url.includes('?')) {
      config.url += '/';
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de RESPOSTA
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 1. Verifica se o erro é de autenticação (401 ou 403)
    // 2. Ignora se o erro for na própria tentativa de login (url que contém "token")
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      if (!error.config.url.includes("token")) {
        
        console.warn("Sessão inválida. Limpando dados...");
        
        // Limpa o armazenamento local
        localStorage.removeItem("token");
        localStorage.removeItem("username");

        // Alerta o usuário e redireciona
        // Usamos window.location.hash porque você está usando HashRouter
        alert("Sua sessão expirou. Por favor, faça login novamente.");
        window.location.href = "#/login"; 
        
        // Recarrega a página para limpar os estados do React Context
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default api;